module.exports = __webpack_public_path__ + "static/img/icon1.5b5c982.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feature/icon1.png
// module id = Mpcy
// module chunks = 1